<template>
  <div class="mt-[3.8rem]">
    <div class="container">
      <Header />
    </div>
  </div>
  <div class="h-20"></div>
  <div class="bg-n3black py-10">
    <div class="container">
      <router-view />
    </div>
  </div>

  <Footer />
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: { Header, Footer },
  setup() {},
};
</script>
<style lang="scss"></style>
